import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { toggleFinancial } from '../../redux/settings';
import FinancialTotals from './FinancialTotals';

const totals = createSelector(
  state => state.events.events,
  events => {
    const uniqueJobs = events
      .filter(e => e.job && !e.tentative)
      .map(e => e.job)
      .reduce((unique, job) => ({ ...unique, [job.id]: job }), {});

    return Object.values(uniqueJobs)
      .reduce(({ actualProfit, estimatedLabor, proposedProfit, revenue }, job) => ({
        actualProfit: actualProfit + (job.profit && job.profit.actualProfit || 0),
        estimatedLabor: estimatedLabor + (job.capacities && job.capacities.laborAmount || 0),
        proposedProfit: proposedProfit + (job.profit && job.profit.proposedProfit || 0),
        revenue: revenue + job.jobTotal
      }), {
        actualProfit: 0,
        estimatedLabor: 0,
        proposedProfit: 0,
        revenue: 0
      });
  }
);

const mapStateToProps = state => ({
  ...totals(state),
  entity: state.settings.entity,
  financialEnabled: state.settings.financialEnabled,
});

const mapDispatchToProps = {
  onToggleFinancial: toggleFinancial,
};

export default connect(mapStateToProps, mapDispatchToProps)(FinancialTotals);
